import { useContext } from "react"
import SidebarContext from "../contexts/SidebarContext/context"
import { closeInfobar, closeSidebar, updateInfobar, updateSidebar } from "../contexts/SidebarContext/actions"
import { InfobarState, SidebarState } from "../contexts/SidebarContext/types"

export const useSidebar = () => {
  const { dispatch } = useContext(SidebarContext)

  const closeSidebarElem = () => {
    dispatch(closeSidebar())
  }

  const updateSidebarElem = (data: SidebarState) => {
    dispatch(updateSidebar(data))
  }

  const closeInfobarElem = () => {
    dispatch(closeInfobar())
  }

  const updateInfobarElem = (data: InfobarState) => {
    dispatch(updateInfobar(data))
  }

  return {
    closeSidebar: closeSidebarElem,
    updateSidebar: updateSidebarElem,
    closeInfobar: closeInfobarElem,
    updateInfobar: updateInfobarElem
  }
}
